import * as postFetch from './fetch/post.js'
import * as store from './data/store.js'
import * as entropy from './data/entropy.js'
import * as routerUtilities from './utilities/router.js'
import * as ui from './ui.js'
import * as refreshDate from './ui/refresh-date.js'
import { formatDateOnly } from './utilities/dates.js'

const api = routerUtilities.getApi()

export async function initialize() {
    const portalLocation = await entropy.getPortalLocation()
    const shouldRememberMe = store.getRememberMe()
    const username = store.getUsername()
    const usernameElement = document.getElementById('js-username')
    usernameElement.value = ""

    if (shouldRememberMe) ui.initializeUsername(username)

    ui.initializeRememberMe({ shouldRememberMe })
    ui.displayFeedyardName({ name: portalLocation.name })
    ui.displayFeedyardPhone({ phone: portalLocation.phone })

    const loginForm = document.getElementById('js-form--login')

    loginForm.addEventListener('submit', validateLogin)
}

function validateLogin(e) {
    e.preventDefault()

    const user = document.getElementById('js-username').value
    const password = document.getElementById('js-password').value

    if (user === '' || password === '') {
        console.error(e)
        return
    }

    login({ user, password })
}

export async function login({ user, password }) {
    const endpoint = `${api}/authenticatePortalUser`

    const primaryLocation = await entropy.getPortalLocation()

    const parameters = {
        user,
        password,
        locationID: primaryLocation.id,
    }

    ui.toggleLoginButton()

    const remember = document.getElementById('js-remember').checked
    store.setRememberMe(remember)
    store.setUsername(user)
    console.info({ remember })
    
    const data = await postFetch.postAFetch({ endpoint, parameters })
    console.info({ data })
    handleLogin({ data })
}

export async function logout() {
    store.removeAuthentication()
    store.removeLocations()
    store.removePortal()

    const shouldRememberMe = store.getRememberMe()
    if (!shouldRememberMe) forgetMe()

    window.location = routerUtilities.setPath({ path: 'login'})
}

function forgetMe() {
    store.removeOwner()
    store.removeUsername()
    store.removeReportLocations()
}

// Check for errors returned from api
// Handle errors
// Save owner
// Save username if desired
/**
 *
 * {"portalUser":"testuser1","owner":"170","ownerFullName":"DCT LLC","ownerEmail":null,"authenticationToken":"162f9a924cdac829cb4cbe3ecf3b4935e17dbbe0450c00b3ec130039d6e8efaa","hasError":false,"errorMessage":null}
 *
 */
async function handleLogin({ data }) {
    console.info({ data })
    ui.toggleLoginButton()

    const loginForm = document.getElementById('js-form--login')
    const passwordElememt = document.getElementById('js-password')
    const errorElement = document.getElementById('js-errors--login')
    const errorMessages = []
    console.info({ errorElement })

    if (data.hasError) {
        console.error(data.errorMessage)
        errorMessages.push(data.errorMessage)
        errorElement.innerHTML = errorMessages.join(', ')
        errorElement.classList.remove('invisible')
        //loginForm.reset()
        passwordElememt.value = ''
        passwordElememt.focus()
    } else {
        const owner = {
            name: data.ownerFullName,
            id: data.owner,
            portalUser: data.portalUser,
        }
        store.setOwner({ owner })

        const authInfo = {
            token: data.authenticationToken,
            expiration: data.authenticationTokenExpiration,
        }

        store.setAuthentication({ authInfo })

		const lastDataRefreshDate = await entropy.getLastRefreshDate()
		store.setDataRefreshDate(lastDataRefreshDate)
		ui.displayLastDataRefreshDate(formatDateOnly(lastDataRefreshDate, 'MM/dd/yyyy'))
		
		const reportSelections = await entropy.getReportSelections()
		store.setReportSelections(reportSelections)		
		
		refreshDate.resetRefreshDateInterval()

        // TODO - Return logged in use to the page they originally tried to access
        window.location = '/'
    }
}